import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FounderCard from "./Components/FounderCard";
import QRSection from "./Components/QRSection";
import "./Founders.scss";

const Founders = () => {
  const { t } = useTranslation();

  // Founder data - Update with actual information
  const founders = [
    {
      id: 1,
      name: "Mustafa Öztürk, PhD",
      title: t("landing.founders.founder1.title"),
      bio: t("landing.founders.founder1.bio"),
      photo: "/FounderImages/MustafaOzturk.jpg",
      phone: "+90 532 300 1915",
      email: "mustafaozturk@cus-pro.com",
      linkedin: "https://www.linkedin.com/in/mustafaozturkhr/",
      whatsappMessage: t("landing.founders.founder1.whatsappMessage"),
    },
    {
      id: 2,
      name: "Ali Onur Can İrey",
      title: t("landing.founders.founder2.title"),
      bio: t("landing.founders.founder2.bio"),
      photo: "/FounderImages/alionurcanirey.jpeg",
      phone: "+90 532 572 8485",
      email: "alionurcanirey@cus-pro.com",
      linkedin: "https://www.linkedin.com/in/ali-onur-can-irey-2659a2170/",
      whatsappMessage: t("landing.founders.founder2.whatsappMessage"),
    },
  ];

  return (
    <div className="founders-page">
      {/* Hero Section */}
      <section className="founders-hero">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h1 className="founders-title">{t("landing.founders.heroTitle")}</h1>
              <p className="founders-subtitle">{t("landing.founders.heroSubtitle")}</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Founders Cards Section */}
      <section className="founders-cards">
        <Container>
          <Row className="justify-content-center g-4">
            {founders.map((founder) => (
              <Col key={founder.id} lg={5} md={6}>
                <FounderCard founder={founder} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* QR Code Section */}
      <QRSection />

      {/* Contact CTA Section */}
      <section className="contact-cta">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <div className="cta-card">
                <h3>{t("landing.founders.ctaTitle")}</h3>
                <p>{t("landing.founders.ctaDescription")}</p>
                <div className="cta-buttons">
                  <a href="mailto:info@cus-pro.com" className="btn btn-primary me-3">
                    {t("landing.founders.ctaEmailButton")}
                  </a>
                  <a href="/contact" className="btn btn-outline-primary">
                    {t("landing.founders.ctaContactButton")}
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Founders;
